module.exports = __webpack_public_path__ + "static/media/square-living-room@2x.5da815ba.jpg";